import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

export const StyledStackWrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(5.25, 8, 8, 8),
  justifyContent: 'space-between',
  border: '1px solid',
  borderColor: theme.palette.border.primary,
  borderRadius: theme.shape.borderRadius * 4,
  backgroundColor: theme.palette.background.secondarySubtle,
  height: '100%',
}));

export const StyledCenteredStack = styled(Stack)(() => ({
  alignItems: 'center',
  textAlign: 'left',
}));
